/**
 * @import {PictureData} from './picture-data.js'
 */
import {assign} from '@acng/frontend-bounty/object.js';
import {unblurThumbnail} from '../service/unblur-preview.js';

/**
 * @param {Record<string, unknown>} data
 */
export const fixPictureData = (data) => {
  // PictureSetData contains wrong type for that.
  // @ts-ignore
  data.fsk = parseInt(data.fsk);

  // PictureSetData contains wrong type for that.
  // @ts-ignore
  data.width = parseInt(data.width);

  // PictureSetData contains wrong type for that.
  // @ts-ignore
  data.height = parseInt(data.height);

  // PictureSetData contains wrong key and wrong type for that.
  // @ts-ignore
  data.set_id ??= data.setId;
  // @ts-ignore
  data.set_id = parseInt(data.set_id);

  delete data.setId;
  delete data.position;
  delete data.base;
};

/**
 * @implements {PictureData}
 */
export class Picture {
  /**
   * @param {PictureData} data
   */
  constructor(data) {
    ASSERT: {
      this.id = data.id;
      this.set_id = data.set_id;
      this.fsk = data.fsk;
      this.width = data.width;
      this.height = data.height;
      this.preview = data.preview;
      this.blurred = data.blurred;
      this.price = data.price;
    }

    assign(this, data);
  }

  /**
   * @deprecated Use `image`
   */
  getImageUrl() {
    return this.preview;
  }

  /**
   * Absolute Image URL
   *
   * TODO CHECK IT!
   */
  get thumbnail() {
    return this.preview;
  }

  /**
   * Absolute Image URL
   *
   * TODO CHECK IT!
   */
  get stockThumbnail() {
    return unblurThumbnail(this);
  }
}
